
import *as THREE from 'three'
import CreatePhysicalObject from './createPhysicalObject'
import SkeletonHelper from './skeletonHelper'
import *as OIMO from 'oimo'
import UpdateStorage from './UpdateStorage'
import ActionBinder from './ActionBinder'
import * as config from './config'
import isDev from 'lib/isDev'
import { throttle } from 'throttle-debounce'
window.THREE = THREE


const tempV = new THREE.Vector3()

export default class {
  constructor(props) {
    this.props = props
    const { freestyle, actions } = props
    
    this.updateStorage = new UpdateStorage()
        
    this.actions = actions
    this.scene = freestyle.parent
    
    this.trashMeshes = []

    
    this.initObjectsLinks()
    this.initHoseHolder()

    this.initCannon()

    this.initPhysicalPlanes()
    this.initDynamicBoxes()
    
    this.initBonesIntoBoxes()
    this.bonesIntoCannon()
    this.initStaticBones()
    this.copyFirstBones()
    window.physics = this

    this.updateStorage.addItem({cb: this.bindVacuumPos})

    // this.updateBones = throttle(100, this.updateBones)
  }

  copyFirstBones = () => {

  }
  
  bindVacuumPos = () => {
    

    // const pos = this.vacuum.position.clone()
    // this.vacuum.parent.localToWorld(pos)
    // pos.x = 0
    // pos.z = 0

    
    // tempV.set(0,0,0)
    
    // const distance = pos.distanceTo(tempV)
    // const distance = pos.distanceTo(new THREE.Vector3(0, 0, 0))
    // const visible = (distance < 26 && distance > 5) || true

    // this.vacuum.visible = true
    // this.vacuum.lookAt(0,0,0)
  }
  
  initObjectsLinks() {
    const { freestyle } = this.props
    
    this.rotateAnim = freestyle.getObjectByName('RotateAnim')
    this.riseAnim = freestyle.getObjectByName('BoomRiseAnim')
    this.reachAnim = freestyle.getObjectByName('ReachAnim')

    this.crane = freestyle.getObjectByName('Crane')

    this.hose = freestyle.parent.getObjectByName('Truck013')
    this.hose_end = freestyle.getObjectByName('hose_end')
    this.hose.visible = false
    // this.vacuum = this.hose.parent.getObjectByName('FreestyleVacuum')

    // this.hose_end.add(this.vacuum)
  }
  
  
  initHoseHolder() {
    this.hoseHolder = new THREE.Mesh(new THREE.BoxGeometry(25, 25, 25), new THREE.MeshPhongMaterial('#ff322d'))    
    this.reachHolder = new THREE.Mesh(new THREE.BoxGeometry(25, 25, 25), new THREE.MeshPhongMaterial({color: '#223223'}))
    this.hoseHolderCopy = this.hoseHolder.clone()
    this.hoseHolderCopy.material.color.set('#fff332')
    
    this.trashMeshes.push(this.hoseHolder, this.reachHolder)
    
    this.riseAnim.add(this.hoseHolder)

    const hoseGlobal = this.hoseHolder.position.clone()
    this.hoseHolder.parent.localToWorld(hoseGlobal)
    
    if(!isDev) {
      this.hoseHolder.visible = false
      this.reachHolder.visible = false
    }
    
    this.reachHolder.position.clone(hoseGlobal)
    
    this.reachAnim.add(this.reachHolder)
    this.hoseHolder.parent.add(this.hoseHolderCopy)
  }
  
  initCannon() {
    this.world = new OIMO.World({
      timestep: this.worldStep,
      iterations: 8, 
      worldscale: 1, // scale full world 
      random: true,  // randomize sample
      gravity: [0,-2500,0] 
      // gravity: [0,0,0] 
    })
  }

  initPhysicalPlanes() {
    this.physicalGround = new CreatePhysicalObject({type: 'ground', world: this.world})

    config.planes.forEach(item => {
      const { width, height, size, depth, position: initialPosition, rotation, move, type} = item      
      const { world } = this

      const plane = new CreatePhysicalObject({
        world,
        depth,
        type,
        move,
        size,
        width,
        height, 
        initialPosition, 
        rotation
      })

      plane.visual.name = item.name
      this.trashMeshes.push(plane.visual)

      if(isDev) this.scene.add(plane.visual)
    })
  }
  
  initDynamicBoxes = () => {
    config.dynamicPlanes.forEach(item => {

      const plane = new CreatePhysicalObject({
        type: 'kinematic',
        world: this.world,
        ...item,
      })

      this.hoseHolder.attach(plane.visual)

      
      const onBoneMove = () => {
        this.hoseHolder.updateMatrixWorld()

        const position = new THREE.Vector3().setFromMatrixPosition(plane.visual.matrixWorld)
        const quaternion = new THREE.Quaternion().setFromRotationMatrix(plane.visual.matrixWorld)
        
        plane.setAll({position, quaternion})        
      }


      const actionBindReach = new ActionBinder({action: this.actions['FreestyleReach'], cb: onBoneMove})
      
      this.updateStorage.addItem({cb: onBoneMove, key: 'bonemove1'})
      this.updateStorage.addItem({cb: actionBindReach.update, key: 'reach1'})

      this.trashMeshes.push(plane.visual)
    })
    
    
  }
 
  initBonesIntoBoxes() {
    const bones = this.hose.skeleton.bones
    // const helper = new SkeletonHelper(this.hose, bones)

    // if(isDev) this.scene.add(helper)
    
    this.defaultBones = bones.map(b => ({position: b.position.clone(), rotation: b.rotation.clone()}))

    const mat = new THREE.MeshPhongMaterial({color: '#ff322d', transparent: true, opacity: .3, visible: isDev})
    // mat.opacity = 0

    this.bonesBoxes = bones.map((bone, i) => {
      // bone.userData.sameStart = i === 0
      // bone.userData.sameEnd = i === config.sameBonesCount
      const isSameStart = i === 0
      const isSameEnd = i === config.sameBonesCount
      const isInSame = !isSameEnd && i < config.sameBonesCount

      if(isSameStart) {
        bone.userData.isSameStart = true 
      }
      if(isSameEnd) {
        bone.userData.isSameEnd = isSameEnd 
      }
      if(isInSame) {
        
      }
      
      if(bone && bone.parent.isBone) {
        this.hose.updateMatrixWorld()
        
        
        // const helper = new THREE.AxesHelper(250)
        if(isDev) {
          // bone.parent.add(helper)
        }
        
        
        const b = tempV.setFromMatrixPosition(bone.matrixWorld)
        const a = tempV.clone().setFromMatrixPosition(bone.parent.matrixWorld)
        
        const size = [30, 30, a.distanceTo(b) - 1.5]
        const geo = new THREE.BoxGeometry(...size)
        const mesh = new THREE.Mesh(geo, mat)
        
        const boneDotStart = new THREE.Mesh(new THREE.SphereGeometry(4, 16, 16), new THREE.MeshStandardMaterial({transparent: true, opacity: 0, emissive: '#ff0033'}))
        const boneDotEnd = new THREE.Mesh(new THREE.SphereGeometry(4, 16, 16), new THREE.MeshStandardMaterial({transparent: true, opacity: 0, emissive: '#5df253'}))
        
        const boneDotPos = new THREE.Vector3(0, 0, size[2])
        const posChecker = new THREE.Mesh(new THREE.SphereGeometry(4, 16, 16), new THREE.MeshStandardMaterial({transparent: true, opacity: 0, emissive: '#ff00ff'}))
        posChecker.visible = false

        boneDotStart.position.copy(boneDotPos.clone()).multiplyScalar(-.5)
        boneDotEnd.position.copy(boneDotPos.clone()).multiplyScalar(.5)
        boneDotEnd.position.z-=2.5
        
        posChecker.visible = isDev
        boneDotStart.visible = isDev
        boneDotEnd.visible = isDev

        mesh.add(boneDotStart)
        mesh.add(boneDotEnd)
      
        const updateBoneDots = () => {
          const fbpos = boneDotStart.position.clone()
          const bdend = boneDotEnd.position.clone()
          mesh.localToWorld(fbpos)
          mesh.localToWorld(bdend)
  
          boneDotStart.pos = fbpos
          boneDotEnd.pos = bdend
        }
        
        this.updateStorage.addItem({cb: updateBoneDots, key: 'uBoneDot'})

        const pos = new THREE.Vector3().addVectors(a, b).multiplyScalar(.5)

        mesh.name = bone.name
        mesh.position.copy(pos)
        mesh.lookAt(b)

        this.hose.add(posChecker)

        this.scene.add(mesh)
        
        this.trashMeshes.push(mesh, boneDotStart, boneDotEnd, posChecker)
        
        return ({
          box: mesh,
          size,
          posChecker,
          bone: bone.parent,
          nextBone: bone,
          boneDotStart,
          boneDotEnd,
          defaultRotation: bone.parent.rotation.clone()
        })
      }
      return undefined
    }).filter(item => item)

    this.boneDistanceDefault = this.bonesBoxes.reduce((acc, b) => acc + b.size[2], 0) / this.bonesBoxes.length 

    this.initCurve()
    
    // if(isDev) {
    //   this.scene.add(helper)
    // }
  }
  
  initCurve() {
    const curveArr = this.bonesBoxes.map((item) => {
      return item.box.position
    }) 
    
    const curve = new THREE.CatmullRomCurve3(curveArr, true)

    const {  normalMap } = this.props.maps
    
    const mat = new THREE.MeshStandardMaterial({
      normalMap,
      color: 0x070707,
      size: THREE.DoubleSide
    })

    const tubeGeometry = new THREE.TubeBufferGeometry(curve, 500, 12, 12, false)
    const tube = new THREE.Mesh(tubeGeometry, mat)

    this.scene.add(tube)
    const lastBox = this.bonesBoxes[this.bonesBoxes.length - 1]
    this.hoseEndOriginamParent = this.hose_end.parent
    lastBox.box.add(this.hose_end)
    this.hose_end.position.copy(lastBox.boneDotEnd.position)


    this.trashMeshes.push(tube)
    this.tube = tube

  }

  chachedPoses = []
  
  updateTubeGeometry() {
    const curveArr = this.bonesBoxes.map((item,i) => {
      let pos 
      if(item.boneCopy) {
        pos = item.boneCopy.position.clone()
        if(i === 0) {
          const distanceForHoseReach = this.hoseHolder.position.distanceTo(this.hoseHolderCopy.position)
          pos.z-=distanceForHoseReach + 20
        }
        item.boneCopy.parent.localToWorld(pos)
      } else {
        pos = item.box.position.clone()
      }
      if(this.chachedPoses[i]) {
        // const isChanged = this.chachedPoses[i].distanceTo(pos) > 0
        const isChanged = true

        if(isChanged) {
          this.chachedPoses[i] = pos
          return pos
        } else {
          return this.chachedPoses[i]  
        }
      }

      this.chachedPoses[i] = pos
      return pos
    })
    const curve = new THREE.CatmullRomCurve3(curveArr, false)

    this.tube.geometry.dispose()
    this.tube.geometry = new THREE.TubeBufferGeometry(curve, 200, 12, 12, false)

  }
  
  bonesIntoCannon() { 
    this.physicalBones = new CreatePhysicalObject({type: 'chain', list: this.bonesBoxes, world: this.world})
    this.updateStorage.addItem({cb: this.physicalBones.update})
  }

  distanceBetweenTwoBoxes_y = 0
  distanceBetweenTwoBoxes_x = 0
  distanceBetweenTwoBoxes_z = 0

  initStaticBones() {
    //creating static bones to controll physical bones
  
    const list = this.bonesBoxes.filter((_, i) => i < config.staticBonesCount)
    
    list.forEach(({box: bone, size}, index) => {
      
      const boneCopy = bone.clone()
      boneCopy.geometry = bone.geometry.clone()
      boneCopy.material = bone.material.clone()
      boneCopy.material.color.set('#ff00ff')

      
      const boneDotStart = new THREE.Mesh(new THREE.SphereGeometry(4, 16, 16), new THREE.MeshStandardMaterial({transparent: true, emissive: '#ff0033'}))
      boneDotStart.position.copy(new THREE.Vector3(0, 0, size[2])).multiplyScalar(-.5)

      boneCopy.add(boneDotStart)
      
      this.bonesBoxes[index].boneCopy = boneCopy
      this.bonesBoxes[index].boneCopyStart = boneDotStart
      boneDotStart.pos = new THREE.Vector3()
      
      this.hoseHolder.attach(boneCopy)
      
      
      const onBoneMove = () => {
        // return
        this.hoseHolder.updateMatrixWorld()

        // boneCopy.pos = 
        const boneCopyG = boneDotStart.position.clone()
        boneDotStart.parent.localToWorld(boneCopyG)
        boneDotStart.pos = boneCopyG
        
        const position = new THREE.Vector3().setFromMatrixPosition(boneCopy.matrixWorld)
        const quaternion = new THREE.Quaternion().setFromRotationMatrix(boneCopy.matrixWorld)

        // position.x+=this.distanceBetweenTwoBoxes_x * 2
        // position.z+=this.distanceBetweenTwoBoxes_z * 2
        position.y= position.y + this.distanceBetweenTwoBoxes_y

        
        this.physicalBones.setAll({position, quaternion, index})

        this.updateTubeGeometry()
      }

      const onReach = () => {
        const pos = this.reachHolder.position.clone()
        this.reachHolder.parent.localToWorld(pos)
        this.hoseHolder.parent.worldToLocal(pos)
        this.hoseHolder.position.copy(pos)
      }

      const actionBindReach = new ActionBinder({action: this.actions['FreestyleReach'], cb: onReach})
      
      this.updateStorage.addItem({cb: onBoneMove, key: 'bonemove'})
      this.updateStorage.addItem({cb: actionBindReach.update, key: 'reach'})

      this.trashMeshes.push(boneCopy)
    })
  }
     
  stopUpdate = false
  updateBones = () => {
    if(this.stopUpdate) return
    this.updateTubeGeometry()
    
    if(this.physicalBones && this.bonesBoxes) {
      this.bonesBoxes.reduce((prevItem, item, i) => {
        const { posChecker, boneDotStart, box, bone, boneCopyStart, defaultRotation, boneCopy } = item



        if(i === config.staticBonesCount) {
          const prevItemPosition = prevItem.boneCopy.position.clone()
          prevItem.boneCopy.parent.localToWorld(prevItemPosition)
          
          const distances = ['x', 'y', 'z'].reduce((acc, item) => {
            return {
              ...acc,
              [item]: prevItemPosition[item] - box.position[item] 
            }
          }, {})

          this.distanceBetweenTwoBoxes_z = distances.z 
          this.distanceBetweenTwoBoxes_x = distances.x
          this.distanceBetweenTwoBoxes_y = distances.y *  1.4
          
          
        }
        return item
      }, undefined)
    }
  }
  
  dispose() {

    this.hose.pose()
    this.hose.visible = false
    
    this.hoseEndOriginamParent.add(this.hose_end)
    
    this.trashMeshes.forEach(item => {
      if(item.parent) {
        item.parent.remove(item)
      }
      if(item.geometry) {
        item.geometry.dispose()
      }
      if(item.material) {
        item.material.dispose()
      }
    })

    this.updateStorage.dispose()
    this.defaultBones.forEach((item, i) => {
      const b = this.hose.skeleton.bones[i]

      b.position.copy(item.position)
      b.rotation.copy(item.rotation)
    })

  }

  applyForce() {
    this.physicalBones.objects.forEach((item, i) => {
    })
  }

  update = (delta) => {
    this.applyForce()

    this.updateStorage.update(delta)
    this.updateBones()
    if(this.world) this.world.step()
  }
}
